import React, { useEffect } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import InputWithIcon from "../../components/FormFields/InputWithIcon";
import SelectInput from "../../components/FormFields/SelectInput";
import CustomButton from "../../components/CustomButton";
import DatePicker from "../../components/FormFields/DatePicker";
import { Form, Formik } from "formik";
import moment from "moment";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import { raiseRequestValidation } from "../../utils/validations/raiseRequest";
import { numberToWords, sendToDBDateFormat } from "../../utils/helpers";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const RaiseARequest = () => {
  const { data = {}, apiCall } = useApi();
  const { apiCall: submitCall } = useApi();
  const navigate = useNavigate();

  useEffect(() => {
    apiCall({
      url: apiUrls.dmsService.getVoucherHeads,
      method: "get",
      processData: (apiData = []) => {
        // let subHeadOptions = {};
        const headOptions = [
          { key: "Please Select", value: "" },
          ...apiData?.map((item) => {
            // subHeadOptions[item?.headName] = [
            //   { key: "Please Select", value: "" },
            //   ...item?.voucherSubHeads.map((subHead) => ({
            //     key: subHead?.subHeadName,
            //     value: subHead?.subHeadName,
            //   })),
            // ];
            return {
              key: item?.headName,
              value: item?.headName,
            };
          }),
        ];
        return { headOptions };
      },
    });
  }, []);

  const onSubmitRequest = (values) => {
    const dataToSend = {
      dataModalAttributeSet: [
        {
          metadataTechnicalName: "date",
          attributeValue: moment(values?.date).format(sendToDBDateFormat),
        },
        { metadataTechnicalName: "head", attributeValue: values?.head },
        // { metadataTechnicalName: "sub_head", attributeValue: values?.sub_head },
        {
          metadataTechnicalName: "description",
          attributeValue: values?.description,
        },
        { metadataTechnicalName: "quantity", attributeValue: values?.quantity },
        { metadataTechnicalName: "rate", attributeValue: values?.rate },

        { metadataTechnicalName: "tax", attributeValue: values?.tax },
        { metadataTechnicalName: "amount", attributeValue: values?.amount },
      ],
      metadataSchemaId: 13,
    };

    submitCall({
      url: apiUrls.dmsService.createRecord,
      dataToSend,
      method: "post",
      onSuccess: () => {
        toast.success("Request has been submitted successfully");
        navigate(-1);
      },
    });
  };

  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Raise A Request"
        showBack
        containerClassName="mt-14"
      />
      <Formik
        enableReinitialize
        initialValues={{
          date: new Date(),
          head: "",
          // sub_head: "",
          description: "",
          quantity: "",
          rate: "",
          tax: "With Tax",
          amount: "",
        }}
        validationSchema={raiseRequestValidation}
        onSubmit={onSubmitRequest}
      >
        {({ errors, touched, values, setFieldValue }) => {
          return (
            <Form>
              <div className="bg-[var(--whiteColor)] rounded-[1rem] mt-6 p-8 flex flex-col gap-y-5">
                <DatePicker
                  title="Date"
                  datePickerClassName="w-[100%]"
                  datePickerTextClassName="text-[var(--textGray2)]"
                  onChange={(date) => {
                    setFieldValue("date", date);
                  }}
                  startDate={values.date}
                  error={touched.date && errors.date}
                  maxDate={new Date()}
                />

                <SelectInput
                  title="Request Head"
                  options={data?.headOptions}
                  wrapperClassName=""
                  onChange={(e) => {
                    setFieldValue("head", e);
                  }}
                  value={values.head}
                  error={touched.head && errors.head}
                />

                {/* <SelectInput
                  title="Sub Head"
                  options={data?.subHeadOptions?.[values?.head]}
                  wrapperClassName=""
                  onChange={(e) => {
                    setFieldValue("sub_head", e);
                  }}
                  value={values.sub_head}
                  error={touched.sub_head && errors.sub_head}
                /> */}

                <InputWithIcon
                  title="Description"
                  containerClassName="!bg-[var(--whiteColor)] border-[1px] border-[var(--borderGray1)] !h-[5rem]"
                  onChange={(e) => {
                    setFieldValue("description", e);
                  }}
                  value={values.description}
                  error={touched.description && errors.description}
                />

                <InputWithIcon
                  title="Quantity"
                  containerClassName="!bg-[var(--whiteColor)] border-[1px] border-[var(--borderGray1)] !h-[5rem]"
                  onChange={(e) => {
                    setFieldValue("quantity", e);
                    if(Number(values.rate) && e){
                      setFieldValue(
                        "amount",
                        Number(values.rate) * Number(e)
                      );
                    }
                  }}
                  value={values.quantity}
                  error={touched.quantity && errors.quantity}
                  type="number"
                />

                <InputWithIcon
                  title="Rate per item (₹)"
                  containerClassName="!bg-[var(--whiteColor)] border-[1px] border-[var(--borderGray1)] !h-[5rem]"
                  onChange={(e) => {
                    setFieldValue("rate", e);
                    if (values.quantity && e) {
                      setFieldValue(
                        "amount",
                        Number(values.quantity) * Number(e)
                      );
                    }
                  }}
                  value={values.rate}
                  error={touched.rate && errors.rate}
                  type="number"
                />

                {/* <SelectInput
                  title="Tax"
                  options={[
                    { key: "With Tax", value: "With Tax" },
                    { key: "Without Tax", value: "Without Tax" },
                  ]}
                  onChange={(e) => {
                    setFieldValue("tax", e);
                  }}
                  value={values.tax}
                  error={touched.tax && errors.tax}
                /> */}

                <div className="flex flex-col">
                  <InputWithIcon
                    title="Total Amount (₹)"
                    containerClassName="!bg-[#F0F0F0] !h-[5rem]"
                    value={values.amount}
                    disabled
                  />
                  {values?.amount ? (
                    <div className="text-[1.2rem] text-[var(--textGray4)] ml-3">
                      ({numberToWords(values.amount)})
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="flex justify-between mt-8 gap-x-10">
                <CustomButton
                  title="Discard"
                  wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8 w-[50%]"
                  onClick={() => {
                    navigate(-1)
                  }}
                />
                <CustomButton
                  title="Send Request"
                  wrapperClassName="!px-8 w-[50%]"
                  type="submit"
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default RaiseARequest;
